import MicroModal from 'micromodal';

export const Modals = (function () {
	"use strict";

	const modalOptions = {
		onShow: (modal, element, event) => openTheModal(modal, element, event), // [1]
		onClose: (modal, element, event) => closeTheModal(modal, element, event), // [2]
		openTrigger: 'data-mircomodal-open', // [3]
		closeTrigger: 'data-mircomodal-close', // [4]
		openClass: 'is-open', // [5]
		disableScroll: true, // [6]
		disableFocus: true, // [7]
		awaitOpenAnimation: true, // [8]
		awaitCloseAnimation: true, // [9]
		debugMode: false // [10]
	}

	const openTheModal = (modal, element, event) => {
		history.replaceState(null, null, `#${modal.id}`);
	};

	const closeTheModal = (modal, element, event) => {
		// console.log('Close Fired', modal);
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}
		modal.classList.remove('is-open');
		history.replaceState(null, null, ` `);
	};

	// const changeTheModal = (e, current, changeTo, isPrev) => {
	// 	// Vars
	// 	let changeID = isPrev ? changeTo.dataset.modalNavPrev : changeTo.dataset.modalNavNext;
	// 	// Stop Default
	// 	e.preventDefault();
	// 	e.stopPropagation();
	// 	// Closes Current Modal
	// 	MicroModal.close(current.id);
	// 	current.classList.remove('is-open');
	// 	// Opens Target Modal
	// 	MicroModal.show(changeID, modalOptions);
	// 	// Replace URL
	// 	history.replaceState(null, null, `#${changeID}`);
	// }

	const checkModalOnloadStatus = () => {
		// if there is a hash that is longer than 0 characters AND if there is a modal on the page with that id
		if (window.location.hash.length > 2 && $("#" + window.location.hash.substring(1) + ".modal").length > 0) {
			MicroModal.show(window.location.hash.substring(1), modalOptions);
		}
	}

	// const setModalNavigation = () => {
	// 	let modalsWithNav = document.querySelectorAll('.modal--has-nav');
	// 	if (modalsWithNav && modalsWithNav.length > 0) {
	// 		modalsWithNav.forEach(modalWithNav => {
	// 			let current = modalWithNav.id;
	// 			let prev = modalWithNav.querySelector('[data-modal-nav-prev]') ?? false;
	// 			let next = modalWithNav.querySelector('[data-modal-nav-next]') ?? false;

	// 			// console.log('np', prev, prev.dataset.modalNavPrev.length)
	// 			// if(prev & prev.dataset.modalNavPrev.length > 0) {
	// 			prev.addEventListener(mytap, (e) => {
	// 				changeTheModal(e, modalWithNav, prev, true);
	// 			});
	// 			// }
	// 			// if(next && next.dataset.modalNavNext.length > 0) {
	// 			// console.log('nn', next, next.dataset.modalNavNext.length)
	// 			next.addEventListener(mytap, (e) => {
	// 				changeTheModal(e, modalWithNav, next, false);
	// 			});
	// 			// }
	// 		});
	// 	}
	// }

	// Make sure that ajax-triggering links are watched. If one is clicked, re-create the list of ajax-triggering links (self-referential)
	// and re-set up the MicroModal to watch the new selection of modal triggers on the page
	// @author Aaron Hodge Silver
	const tagAjaxLinks = () => {
		var ajaxLinks = document.querySelectorAll(".ajax_trigger a");
		if (ajaxLinks && ajaxLinks.length > 0) {
			ajaxLinks.forEach((onelink) => {
				onelink.addEventListener(mytap, (e) => {
					setTimeout(function () {
						tagAjaxLinks();
						MicroModal.init(modalOptions);
					}, 1500);
				});
			});
		}
	};

	const mytap = window.ontouchstart === null ? "touchstart" : "click";

	function init() {

		MicroModal.init(modalOptions);
		checkModalOnloadStatus();
		// setModalNavigation(); // Aaron commented this out on Sept 6 2023. Also the setModalNavigation() and setModalNavigation() functions. Angel wrote those, and they don't work and they often break other JS on the site.

		// If anyone clicks an ajax link that might change page content, add listeners to all new items
		tagAjaxLinks();

	}

	return {
		init: init,
	};
})();
